// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kpkfuI8LCMjQfVu6bTuR{flex-direction:column;flex:1;gap:12px;padding:20px;display:flex}.kpkfuI8LCMjQfVu6bTuR:not(:last-child){border-right:1px solid var(--interaction-neutral-normal)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"metricCard": `kpkfuI8LCMjQfVu6bTuR`
};
export default ___CSS_LOADER_EXPORT___;
